import "./App.css";
import ConnectWalletModal from "./Components/ConnectWalletModal.jsx";
import { useState } from "react";
import WalletAccessModal from "./Components/WalletAccessModal.jsx";
import WalletConnectModal from "./Components/WalletConnectModal.jsx";

import SwapCard from "./Components/SwapCard.jsx";
function App() {
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);

  return (
    <main>
      <div
        className={`${showModal || showModal2 || showModal3 ? "blur-md" : ""}`}
      >
        <SwapCard setShowModal={setShowModal} />
      </div>
      <ConnectWalletModal
        isOpen={showModal}
        setShowModal3={setShowModal3}
        onClose={() => setShowModal(false)}
        setShowModal2={setShowModal2}
      />
      <WalletAccessModal
        isOpen={showModal2}
        onClose={() => setShowModal2(false)}
      />
      {showModal3 && (
        <WalletConnectModal
          setWalletCn={setShowModal3}
          setModal={setShowModal}
          setImportWallet={setShowModal2}
        />
      )}
    </main>
  );
}

export default App;
